'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import type { ClassValue } from 'clsx';
import type { ReactNode } from 'react';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import { TopNavV5MobileCloseHeader } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileCloseHeader';
import { TopNavV5MobileLeftMenu } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileLeftMenu';
import { TopNavV5MobileMenu } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileMenu';
import { TopNavV5MobileSubMenu } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileSubMenu';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
const asideClassNames = 'size-full bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 text-white z-max duration-200 transition-all transition ease-out flex flex-col';
const Panel = t0 => {
  const $ = _c(17);
  const {
    open,
    onClose,
    className,
    content
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(asideClassNames, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose) {
    t2 = <TopNavV5MobileCloseHeader onClick={onClose} />;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== content) {
    t3 = <div className="flex-1 overflow-y-auto">{content}</div>;
    $[4] = content;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <TransitionChild><DialogPanel className={t1}>{t2}{t3}</DialogPanel></TransitionChild>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== open || $[11] !== t4) {
    t5 = <Transition show={open} as="div" className="fixed inset-0">{t4}</Transition>;
    $[10] = open;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onClose || $[14] !== open || $[15] !== t5) {
    t6 = <Dialog transition={true} className="relative z-max transition duration-200 ease-out" onClose={onClose} open={open} static={true}>{t5}</Dialog>;
    $[13] = onClose;
    $[14] = open;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export const TopNavV5MobileSlidingPanel = () => {
  const $ = _c(4);
  const {
    mobileState,
    mobileDispatch
  } = useTopNavV5();
  const {
    isDesktop
  } = useBreakpoints();
  if (isDesktop) {
    return null;
  }
  let t0;
  if ($[0] !== mobileDispatch || $[1] !== mobileState.previousState || $[2] !== mobileState.state) {
    const renderContent = () => <><Panel open={mobileState.state === "open"} onClose={() => mobileDispatch({
        type: "CLOSE_FROM_MAIN"
      })} content={<TopNavV5MobileMenu />} className="translate-x-0 data-closed:-translate-x-full" /><Panel open={mobileState.state === "sub-menu-open"} onClose={() => mobileDispatch({
        type: "CLOSE_FROM_SUB_MENU"
      })} content={<TopNavV5MobileSubMenu />} className={{
        "data-closed:translate-x-full": true,
        "data-closed:-translate-x-full": mobileState.state === "closed"
      }} /><Panel open={mobileState.state === "left-menu-open"} onClose={() => mobileDispatch({
        type: "CLOSE_FROM_LEFT_MENU"
      })} content={<TopNavV5MobileLeftMenu />} className={{
        "data-closed:translate-x-full": true,
        "data-closed:-translate-x-full": mobileState.state === "closed" || mobileState.state === "left-menu-open" && mobileState.previousState === "left-menu-sub-menu-open" || mobileState.state === "left-menu-sub-menu-open"
      }} /><Panel open={mobileState.state === "left-menu-sub-menu-open"} onClose={() => mobileDispatch({
        type: "CLOSE_FROM_LEFT_MENU_SUB_MENU"
      })} content={<TopNavV5MobileSubMenu />} className={{
        "data-closed:translate-x-full": true,
        "data-closed:-translate-x-full": mobileState.state === "closed"
      }} /></>;
    t0 = <>{renderContent()}</>;
    $[0] = mobileDispatch;
    $[1] = mobileState.previousState;
    $[2] = mobileState.state;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};